import { ajax, uploadImg } from "./request.js";
import until from "./until.js";
import vue from "vue";

vue.config.productionTip = false;

function getRequestLang(type) {
  if (type === "zh-cn") return "zh-cn";
  else if (type === "en") return "en-us";
  else return "zh-cn";
}

// var baseUrl =
//   process.env.NODE_ENV === "development" ? "" : "http://43.135.4.137:8088"; // 测试服

var baseUrl =
  process.env.NODE_ENV === "development"
    ? ""
    : "https://apiv2.faceline.live:443"; // 正式服

function getRequestUrl(url, aa) {
  let query = "";
  if (aa) {
    query = `&noOther=${aa.noOther}&area=${aa.area}`;
  }
  return (
    baseUrl +
    url +
    `?lang=${getRequestLang(
      vue.prototype.$selfGlobal.$globalStore.state.locale
    )}` +
    query
  );
}

// 登录
function login(data, config) {
  return ajax("post", getRequestUrl("/v1/manager/login"), data, config);
}

// 退出登录
function loginOut() {
  return ajax("post", getRequestUrl("/api/Login/logout"), {});
}

// 操作密码
function checkAdminPwd(data) {
  return ajax("post", getRequestUrl("/api/Admin/checkAdminPwd"), data);
}

// 导出表格
function exportData(arr) {
  let url = baseUrl + "/api/Service/servicekProblemListExport?" + arr.join("&");
  window.open(url, "_blank");
}

// 上传图片
function upload(data) {
  let UPS = until.upImgSize({ target: { files: [data.get("file")] } });
  if (!UPS) {
    vue.prototype.$Message.info("文件过大，请重新选择！");
    // vue.prototype.$Notice.config({
    //   title: "上传限制",
    //   desc: "文件过大，请重新选择！"
    // });
    return;
  }
  return uploadImg(getRequestUrl("/v1/mgr/gift/image"), data);
}

// 视频聊天 (数据统计)
function videoChatStatistics(data, method) {
  return ajax("post", getRequestUrl("/v1/video/data"), data, {
    method
  });
}

// 管理员 -- 列表
function getAdminList(data, method) {
  return ajax("get", getRequestUrl("/admin/administrator/index"), data, {
    method
  });
}

// 管理员 -- 添加
function createAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/create"), data, {
    method
  });
}

// 管理员 -- 删除
function deleteAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/delete"), data, {
    method
  });
}

// 管理员 -- 更新
function updateAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/update"), data, {
    method
  });
}

// 管理员 -- 查看他的权限
function getPermission(data, method) {
  return ajax("get", getRequestUrl("/v1/manager/permission"), data, {
    method
  });
}

// 管理员 -- 修改他的权限
function editPermission(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/permission"), data, {
    method
  });
}

// 管理人 -- 设置代理销售明细可查询国家
function settCountryList(data, method) {
  return ajax("get", getRequestUrl("/v2/country/list"), data, {
    method
  });
}
// 管理人 -- 设置可发放奖励区域可查询国家
// function settDataAreaList(data, method) {
//   return ajax("get", getRequestUrl("/v2/dataArea/country/list"), data, {
//     method
//   });
// }
// 管理员 -- 设置代理销售明细可查询国家(确定)
function setSave(data, method) {
  return ajax("post", getRequestUrl("/v2/country/mgrUser/set"), data, {
    method
  });
}
// 管理人 -- 设置代理销售明细可查询国家(确定)
function setUserSave(data, method) {
  return ajax("post", getRequestUrl("/v2/mgrUser/chargeCountry/set"), data, {
    method
  });
}
// 管理员 -- 设置国家经理数据面板(确定)
function setAgencySave(data, method) {
  return ajax("post", getRequestUrl("/v1/dataPanel/country/set"), data, {
    method
  });
}
// 管理员 -- 设置可发放奖励区域(确定)
function setDataAreaSave(data, method) {
  return ajax("post", getRequestUrl("/v1/dataArea/country/set"), data, {
    method
  });
}

// 管理员 -- 设为仅好友可见
function setBroadcastSave(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/friend"),
    data,
    {
      method
    }
  );
}
// 管理员 -- 取消仅好友可见
function delBroadcastSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/global/broadcast/friend/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 管理员 -- 设为广场管理人
function setIsManagerSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/moment/manager"), data, {
    method
  });
}
// 管理员 -- 删除广场管理人
function delIsManagerSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/moment/manager/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 管理员 -- 设为不被踢出房间
function setRoomSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/cannot/kickoutroom"), data, {
    method
  });
}
// 管理员 -- 删除不被踢出房间
function delSetRoomSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/cannot/kickoutroom/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 管理员 -- 设为麦位管理人
function setMicrophoneSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/micOptPower"), data, {
    method
  });
}
// 管理员 -- 删除麦位管理人
function delMicrophoneSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/micOptPower/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 管理员 -- 踢出房间管理人
function setRoomManagerSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/kickOutRoomManager"), data, {
    method
  });
}
// 管理员 -- 删除踢出房间管理人
function delRoomManagerSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/kickOutRoomManager/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 管理员 -- 设为资料管理人
function setDataSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/info/manager"), data, {
    method
  });
}
// 管理员 -- 删除资料管理人
function delDataSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/info/manager/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 礼品 -- 礼物列表
function giftIndex(data, method) {
  return ajax("get", getRequestUrl("/v1/gift/page"), data, {
    method
  });
}

// 礼品 -- 礼物修改
function giftUpdate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/gift/edit"), data, {
    method
  });
}

// 礼品 -- 礼物创建
function giftCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/gift/add"), data, {
    method
  });
}

// 礼品 -- 礼物下架
function giftSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/gift/switch"), data, {
    method
  });
}

// 礼品 -- 礼物详情
function giftDetail(data, method) {
  return ajax("get", getRequestUrl("/admin/gift/detail"), data, {
    method
  });
}

// 客服 -- 反馈信息列表
function reportFeedbacks(data, method) {
  return ajax("get", getRequestUrl("/v1/customer/feedback"), data, {
    method
  });
}

// 客服 -- 举报列表
function reportList(data, method) {
  return ajax("get", getRequestUrl("/v1/customer/report"), data, {
    method
  });
}

// 客服 -- 封禁用户
function reportBanUser(data, method) {
  return ajax("post", getRequestUrl("/admin/user/ban"), data, {
    method
  });
}

// 客服 -- 处理投诉
function reportHandle(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/report"), data, {
    method
  });
}

// 用户 -- 用户信息列表
function usersList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/page"), data, {
    method
  });
}

// 修改用户性别
function updateSex(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/sex"), data, {
    method
  });
}
// 修改是否推荐
function updateRecommend(data, method) {
  return ajax("put", getRequestUrl("/v1/notRecommend"), data, {
    method
  });
}

// 用户 -- 用户设置工会
function userUnionUpdate(data, method) {
  return ajax(
    "post",
    getRequestUrl(`/v1/mgr/user/tradeUnion/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户/工会用户连接日志
function usersConnects(data, method) {
  return ajax("get", getRequestUrl("/v1/user/video"), data, {
    method
  });
}

// 用户 -- 用户明细
function chargePayments(data, method) {
  return ajax("get", getRequestUrl("/v1/user/charge"), data, {
    method
  });
}

// 用户 -- 用户（充值记录）更新为（充值统计）
function usersPayments(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/user/charge/summary/${data.userId}/${data.period}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 消费记录
function usersConsume(data, method) {
  return ajax("get", getRequestUrl("/v1/user/consume"), data, {
    method
  });
}

// 用户 -- 用户赠送宝石
function usersPaymentsCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamond/send"), data, {
    method
  });
}

// 用户 -- 用户赠送游戏币
function usersSendGameMonty(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamondPink/send"), data, {
    method
  });
}

// 用户 -- 消费统计
function statsConsume(data, method) {
  return ajax("get", getRequestUrl("/v1/stats/consume"), data, {
    method
  });
}

// 用户 -- 扣除钻石
function diamondReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamond/reduce"), data, {
    method
  });
}

// 用户 -- 扣除金币
function goldReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/gold/reduce"), data, {
    method
  });
}

// 用户 -- 增加vip天数
function usersVipCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/vip/day"), data, {
    method
  });
}
// 用户 -- 删除vip
function deleteVip(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/vip/${method.userId}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户详情 -- 筛选接口
function userSearch(data, method) {
  return ajax("get", getRequestUrl("/v1/user/detail"), data, {
    method
  });
}

// 用户 -- 用户处理 -- 用户处理（冻结，解冻）
function userDeal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/deal"), data, {
    method
  });
}

// 用户 -- 用户处理 -- 用户处理（封禁广播）
function userBroadcast(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/limit"),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户处理 -- 用户处理（解除封禁广播）
function relieveUserBroadcast(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/allow"),
    data,
    {
      method
    }
  );
}

// 用户（赠送贵族）
function sendNobility(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/noble/user"), data, {
    method
  });
}

// 用户（赠送道具）
function sendProps(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/bag/send"), data, {
    method
  });
}

// 用户（退出家族）
function userLeave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower/user/leave"), data, {
    method
  });
}

// 用户（设为超管）
function addManager(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/super/manager"), data, {
    method
  });
}

// 用户（取消超管）
function delManager(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/super/manager/${method.userId}`),
    data,
    {
      method
    }
  );
}

// 用户（设为全球广播管理人）
function addBroadcastAdministrator(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/manager"),
    data,
    {
      method
    }
  );
}

// 用户（取消全球广播管理人）
function delBroadcastAdministrator(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/global/broadcast/manager/${method.userId}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 移除公会用户
// function userTradeUnionDel(data, method) {
//   return ajax(
//     "delete",
//     getRequestUrl(`/v1/mgr/user/tradeUnion/${method.code}`),
//     data,
//     {
//       method
//     }
//   );
// }

// 用户 -- 封禁设备
function banDevice(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/imei"), data, {
    method
  });
}

// 用户 -- 解除封禁设备
function unBanDevice(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/imei/${method.imei}`), data, {
    method
  });
}

// 用户 -- 国家列表
function getCountryList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/country"), data, {
    method
  });
}

// 用户 -- 国家列表(分区)
function getCountryArea(data, method) {
  return ajax("get", getRequestUrl(`/v1/user/country/${method.area}`), data, {
    method
  });
}

//
// 用户 -- 国家列表v2
function getCountryListTwo(data, method) {
  return ajax("get", getRequestUrl("/v2/country/mgrUser/list"), data, {
    method
  });
}

// 用户 -- 加入推荐
function userRecommend(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/recommend"), data, {
    method
  });
}

// 用户 -- 删除用户
function manageDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/logic/${method.userId}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 重置用户头像
function resetAvatar(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/avatar/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 相册
function getUserPhoto(data, method) {
  return ajax("get", getRequestUrl("/v1/user/photo"), data, {
    method
  });
}

// 用户 -- 删除相册图片
function photoDelete(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/photo/${method.id}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 添加运营备忘
function userMemo(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/memo"), data, {
    method
  });
}
// 用户 -- 修改svip等级
function userSvipLevel(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/svip"), data, {
    method
  });
}
// 用户 -- 增加svip积分--二次确认查询等级-积分
function userPointCount(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/user/svip/checkPoints"), data, {
    method
  });
}
// 用户 -- 增加svip积分
function userSvipPoints(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/svip/points"), data, {
    method
  });
}
// 用户 -- 延长过期时间
function userSvipTime(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/svip/day"), data, {
    method
  });
}
// 用户 -- 修改昵称
function updateUserNick(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/nick"), data, {
    method
  });
}

// 用户 -- 修改等级（财富、魅力、活跃）
function updateUserLevel(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/grade"), data, {
    method
  });
}

// 用户 -- 修改成靓号
function updateUserCode(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/code"), data, {
    method
  });
}

// 用户 -- 删除用户靓号
function resetUserCode(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/code/reset"), data, {
    method
  });
}

// 用户 -- 查看道具
function checkProp(data, method) {
  return ajax("get", getRequestUrl(`/v1/user/property/${data.userId}`), data, {
    method
  });
}

// 用户 -- 删除道具
function deleteProp(data, method) {
  return ajax(
    "put",
    getRequestUrl(`/v1/mgr/user/property/${data.userId}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 钻石收入记录
function diamondIncomeList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/diamondIncome"), data, { method });
}

// 用户 -- 收送礼记录
function giftOperateList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/giftOperate"), data, { method });
}

// 设为主播 / 加入公会
function addTradeUnion(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/tradeUnion"), data, {
    method
  });
}

// 取消主播 / 加入公会
function deleteTradeUnion(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/tradeUnion/${data.userId}`),
    data,
    {
      method
    }
  );
}

// 用户-设为国家管理员/助理
function countryAdministration(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/country/manager"), data, {
    method
  });
}

// 用户-删除国家管理员/助理
function deleteAdministration(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/country/manager/${data.userId}`),
    data,
    {
      method
    }
  );
}

// 用户-创建账号
function createCode(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/create"), data, {
    method
  });
}

// 用户--封禁IP
function banInterface(data, method) {
  return ajax("post", getRequestUrl("/v1/user/ip/ban"), data, {
    method
  });
}
// 用户--解除封禁IP
function banRescind(data, method) {
  return ajax("post", getRequestUrl("/v1/user/ip/ban/del"), data, {
    method
  });
}

// 公会 -- 公会列表
function unionUserList(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/page"), data, {
    method
  });
}

// 公会 -- 上传封面
function associationAvatar(data, method) {
  return ajax("put", getRequestUrl("/v1/guildUser/avatar"), data, {
    method
  });
}

// 公会 -- 匹配记录
function unionConnectList(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/video"), data, {
    method
  });
}

// 公会 -- 公会用户详情
function unionConnectDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/detail"), data, {
    method
  });
}

// 公会 -- 指标统计
function unionConnectStats(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/stats"), data, {
    method
  });
}

// 代理 -- 公会 -- 更新公会代理
function updateAgentUnion(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/tradeUnionAgent"), data, {
    method
  });
}

// 代理 -- 更新工会代理名字
function updateAgentName(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 公会列表 分页
function agentListPage(data, method) {
  return ajax("get", getRequestUrl("/v1/tradeUnion/agent/page"), data, {
    method
  });
}

// 代理 -- 添加
function addAgentPage(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 编辑
function editAgentPage(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 删除
function deleteAgentPage(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/tradeUnion/agent/${method.id}`),
    data,
    {
      method
    }
  );
}

// 代理 -- 设置代理管理员
function editAgentMgr(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agentMgr"), data, {
    method
  });
}

// 代理 -- 删除代理管理员
function deleteAgentMgr(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/tradeUnion/deleteAgentMgr/${method.agentId}`),
    data,
    {
      method
    }
  );
}

// 代理 -- 设置starchatId
function setStarchatId(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/starchatId"), data, {
    method
  });
}

// 匹配日志
function matchCyclePage(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/page"), data, {
    method
  });
}

// 匹配周期结果详情
function matchCyclePageDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/detail/page"), data, {
    method
  });
}

// 匹配周期详情页下的优先度
function matchLogSTotalDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/priority"), data, {
    method
  });
}

// 匹配周期关系总分
function matchLogSRelation(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/relation"), data, {
    method
  });
}

// 匹配周期详情页下的质量
function matchLogExcellent(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/excellent"), data, {
    method
  });
}

// 1.1.4 匹配总分详情页 -- 前三个分值关系分值高的用户
function matchLogRelationTop(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/relation/top"), data, {
    method
  });
}

// 落单用户
function matchLogSingle(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/single"), data, {
    method
  });
}

// 匹配 -- 用户匹配推送记录
function matchRpc(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/rpc"), data, {
    method
  });
}

// 平台运营数据 -- 日统计列表
function dailyStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/day/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 月统计
function monthStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/month/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 总统计
function totalStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/total/${method.area}`), data, {
    method
  });
}
// 平台运营数据 -- VIP充值明细
function viplStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/vip/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 周统计
function weekStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/week/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 充值明细
function rechargeStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/stats/charge/detail/${method.area}`),
    data,
    {
      method
    }
  );
}

// 平台运营数据 -- 消费统计
function consumeStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/consume/${method.area}`), data, {
    method
  });
}

// 推荐用户管理 -- 列表
function recommendPage(data, method) {
  return ajax("get", getRequestUrl("/v1/recommend/page"), data, {
    method
  });
}

// 推荐用户管理 -- 移除推荐用户列表
function recommendDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/recommend/${method.userId}`),
    data,
    {
      method
    }
  );
}

// 管理人 -- 查询管理人
function managerPage(data, method) {
  return ajax("get", getRequestUrl(`/v1/manager/page`), data, {
    method
  });
}

// 管理人 -- 编辑管理人
function managerEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/manager`), data, {
    method
  });
}

// 管理人 -- 增加管理人
function managerAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/manager`), data, {
    method
  });
}

// 管理人 -- 禁用管理人
function managerNoUser(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/no/user`), data, {
    method
  });
}

// 国家经理数据面板 -- 日统计
function dayStatsList(data, method) {
  return ajax("get", getRequestUrl("/v1/dataPanel/dayStats"), data, { method });
}
// 国家经理数据面板 -- 月统计
function monthStatsList(data, method) {
  return ajax("get", getRequestUrl("/v1/dataPanel/monthStats"), data, {
    method
  });
}
// 国家经理数据面板 -- 推广员统计
function promotionStatsList(data, method) {
  return ajax("get", getRequestUrl("/v1/dataPanel/promotionStats"), data, {
    method
  });
}
// 国家经理数据面板 -- 代理统计
function dealerStatsList(data, method) {
  return ajax("get", getRequestUrl("/v1/dataPanel/dealerStats"), data, {
    method
  });
}
// 国家经理数据面板 -- 国家列表v3
function getCountryListTree(data, method) {
  return ajax("get", getRequestUrl("/v2/dataPanel/country/list"), data, {
    method
  });
}

// 公会用户 -- 所有的公会用户
function agentAll(data, method) {
  return ajax("get", getRequestUrl(`/v1/tradeUnion/agent/all`), data, {
    method
  });
}

// 广告 -- 查询广告
function advertiseList(data, method) {
  return ajax("get", getRequestUrl(`/v1/advertise/`), data, {
    method
  });
}

// 广告 -- 修改广告
function advertiseEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/advertise`), data, {
    method
  });
}

// 广告 -- 增加广告
function advertiseAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/advertise`), data, {
    method
  });
}

// 广告 -- 广告上下架
function advertiseSwitch(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/advertise/switch`), data, {
    method
  });
}

// 活动 -- 活动列表 获取所有活动配置
function activityList(data, method) {
  return ajax("get", getRequestUrl(`/v1/activity/config`), data, {
    method
  });
}

// 活动 -- 修改活动 修改活动配置
function activityEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/activity/config`), data, {
    method
  });
}

// 活动 -- 添加活动 增加活动配置
function activityAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/activity/config`), data, {
    method
  });
}

//  道具 -- 修改道具
function propertyEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/property`), data, {
    method
  });
}

//  道具 -- 添加道具
function propertyAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/property`), data, {
    method
  });
}

//  道具 -- 添加道具给用户
function propertyAddToUser(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/property/add`), data, {
    method
  });
}

//  道具 -- 删除用户道具
function propertyRemoveToUser(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/property/remove`), data, {
    method
  });
}

//  道具 -- 道具列表 获取所有道具配置
function propertyList(data, method) {
  return ajax("get", getRequestUrl(`/v1/property/`), data, {
    method
  });
}

//  道具 -- 道具列表 获取所有该用户的道具配置
function propertyUserList(data, method) {
  return ajax("get", getRequestUrl(`/v1/property/${method.id}`), data, {
    method
  });
}

//  群组 -- 查询群组
function groupList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/"), data, {
    method
  });
}

//  群组 -- 群组名称--限制修改
function putEditNameCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/editNameCd"), data, {
    method
  });
}
//  群组 -- 群组名称--解除限制
function deleteEditNameCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/editNameCd/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}
//  群组 -- 群组介绍--限制修改
function putEditIntroductionCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/editIntroductionCd"), data, {
    method
  });
}
//  群组 -- 群组介绍--解除限制
function deleteEditIntroductionCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/editIntroductionCd/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}
//  群组 -- 群组公告--限制修改
function putEditNotificationCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/editNotificationCd"), data, {
    method
  });
}
//  群组 -- 群组公告--解除限制
function deleteEditNotificationCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/editNotificationCd/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}
//  群组 -- 群组头像--限制修改
function putGroupEditAvatarCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/editAvatarCd"), data, {
    method
  });
}
//  群组 -- 群组头像--解除限制
function deleteEditAvatarCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/editAvatarCd/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}
//  群组 -- 群组背景（自定义主题）--限制修改
function putGroupEditCustomThemeCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/editCustomThemeCd"), data, {
    method
  });
}
//  群组 -- 群组背景（自定义主题）--解除限制
function deleteEditCustomThemeCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/editCustomThemeCd/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}

//  群组 -- 查询群组-banner
function getgroupBanner(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/page"), data, {
    method
  });
}

//  群组 -- 解封群组
function groupAllow(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/allow"), data, {
    method
  });
}

//  群组 -- 封禁群组
function groupBan(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/ban"), data, {
    method
  });
}

//  群组 -- 置顶
function groupOnTop(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/onTop"), data, {
    method
  });
}

//  群组 -- 取消置顶
function groupOnTopCancel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/onTop/${encodeURIComponent(method.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}

//  群组 -- 修改资料
function groupProfile(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/profile"), data, {
    method
  });
}
//  群组 -- 修改背景（自定义主题）
function putGroupCustomTheme(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/customTheme"), data, {
    method
  });
}
//  群组 -- 删除背景（自定义主题）
function deleteGroupCustomTheme(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/customTheme/${encodeURIComponent(data.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}
// 群组 -- 设置靓号
function groupBeautifulCodePut(data, method) {
  return ajax(
    "put",
    getRequestUrl(
      `/v1/mgr/group/beautifulCode/${encodeURIComponent(method.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}

// 群组 -- 移除靓号
function groupBeautifulCodeDelete(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/beautifulCode/${encodeURIComponent(method.imGroupId)}`
    ),
    data,
    {
      method
    }
  );
}

// 群组 -- （在群热门中）隐藏/取消隐藏
function putGrouphide(data, method) {
  return ajax(
    "put",
    getRequestUrl(`/v1/mgr/group/hide/${encodeURIComponent(method.imGroupId)}`),
    data,
    {
      method
    }
  );
}
// 群组 -- 设置/取消行政房间
function putPolicy(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/policy"), data, {
    method
  });
}
// 群组 -- 推荐/不推荐房间
function putRecommend(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/not_recommend"), data, {
    method
  });
}

//  群组 -- 查询群组经理（角色）列表
function roleList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/group/role"), data, {
    method
  });
}
//  群组 -- 新增群组经理（角色）
function getAddRole(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/group/role"), data, {
    method
  });
}
//  群组 -- 删除群组经理（角色）
function delRole(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/role/${encodeURIComponent(data.imGroupId)}/${data.userId}`
    ),
    data,
    {
      method
    }
  );
}

//  群组 -- 查询群组黑名单列表
function blackList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/group/blacklist"), data, {
    method
  });
}
//  群组 -- 新增群组黑名单
function getAddBlack(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/group/blacklist"), data, {
    method
  });
}
//  群组 -- 删除群组黑名单
function delBlack(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/mgr/group/blacklist/${encodeURIComponent(data.imGroupId)}/${
        data.userId
      }`
    ),
    data,
    {
      method
    }
  );
}

// 房间管理--房间活动管理--列表
function getRoomList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/list"), data, {
    method
  });
}
//  房间管理 -- 房间活动管理 -- 添加活动
function getAddCreateAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeAct/create"), data, {
    method
  });
}
//  房间管理 -- 房间活动管理 -- 编辑活动
function getUpdateAct(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeAct/update"), data, {
    method
  });
}
// 房间管理 -- 活动上下架
function actSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeAct/status"), data, {
    method
  });
}
// 房间管理--房间审批--列表
function getExamineList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/audit/list"), data, {
    method
  });
}

//  房间管理 -- 特权操作记录 -- 列表
function getPrivilegeList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/audit/list"), data, {
    method
  });
}

//  房间管理 -- 特殊房间充值活动 -- 活动列表
function getRoomSpecList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 添加活动
function getAddSpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/create"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 编辑活动
function getUpdateSpecAct(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeSpecAct/update"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 复制活动
function getCopySpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/copy"), data, {
    method
  });
}
// 房间管理 --特殊房间充值活动 -- 活动上下架
function actSpecSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeSpecAct/status"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 房间审批
function getExamineSpeList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/audit/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 手动运营发放
function getBackend(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/agentChargeSpecAct/audit/backend"),
    data,
    {
      method
    }
  );
}

//  房间管理 -- 特殊房间充值活动 -- 查询任务1
function getTaskSpecAct(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/task/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 添加任务1
function getAddTaskSpecAct(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/agentChargeSpecAct/task/create"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 编辑任务1
function getEditTaskSpecAct(data, method) {
  return ajax(
    "put",
    getRequestUrl("/v1/agentChargeSpecAct/task/update"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 删除任务1
function delTaskSpecAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/agentChargeSpecAct/task/${data.configId}/${data.taskId}`
    ),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 复制任务1
function getCopyTaskSpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/task/copy"), data, {
    method
  });
}

//  房间管理 -- 特殊房间充值活动 -- 任务 -- 查询奖励1
function getAwardSpecAct(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/award/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动  -- 任务 -- 添加奖励1
function getAddAwardSpecAct(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/agentChargeSpecAct/award/create"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 任务  -- 编辑奖励1
function getEditAwardSpecAct(data, method) {
  return ajax(
    "put",
    getRequestUrl("/v1/agentChargeSpecAct/award/update"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动    -- 任务  -- 删除奖励1
function delAwardSpecAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/agentChargeSpecAct/award/${data.configId}/${data.taskId}/${data.awardId}`
    ),
    data,
    {
      method
    }
  );
}

// 系统消息 -- 常规系统消息列表
function getBannerPage(data, method) {
  return ajax("get", getRequestUrl("/v1/msg/sys/page"), data, {
    method
  });
}
//
// 系统消息 -- 定时消息任务列表
function getBannerTimePage(data, method) {
  return ajax("get", getRequestUrl("/v1/preMsg/sys/page"), data, {
    method
  });
}

// 系统消息 -- 增加系统消息
function addBannerPage(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/msg/sys"), data, {
    method
  });
}

// 系统消息 -- 更新系统消息
function editBannerPage(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/msg/sys"), data, {
    method
  });
}

// 系统消息 -- 删除系统消息
function deleteBannerPage(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/msg/sys/${method.id}`), data, {
    method
  });
}
// 系统消息 -- 删除定时消息任务
function deleteBannerTimePage(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/preMsg/sys/${method.id}`),
    data,
    {
      method
    }
  );
}

// 群发消息 -- 群发消息列表
function getMassTextingPage(data, method) {
  return ajax("get", getRequestUrl("/v1/msg/batch/page"), data, {
    method
  });
}

// 群发消息--群发IM消息
// function massTextingIM(data, method) {
//   return ajax("post", getRequestUrl("/v1/mgr/msg/batch"), data, {
//     method
//   });
// }
function massTextingIM(data, method) {
  return uploadImg(getRequestUrl("/v1/mgr/msg/batch"), data);
}

// 群发消息 -- 撤回群发消息
function withdrawInfoGroup(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/msg/withdraw"), data, {
    method
  });
}

// banner管理 -- banner列表
function bannerManagementList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/page"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerManagementEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerManagementAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/group/banner"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerManagementNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner/nouser"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerManagementUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner/user"), data, {
    method
  });
}
// 群组banner列表

function getBannerRoom(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/room"), data, {
    method
  });
}
// 更新房间banner
function putBannerRoom(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/room/banner"), data, {
    method
  });
}
//上下架房间banner
function putBannerRoomStatus(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/room/banner/status"), data, {
    method
  });
}
// 新增房间banner
function postBannerRoom(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/room/banner"), data, {
    method
  });
}

// 代理banner -- banner列表
function bannerAgentList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/agent/banners"), data, {
    method
  });
}

// 代理banner -- 编辑banner
function bannerAgentEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner"), data, {
    method
  });
}

// 代理banner -- 添加banner
function bannerAgentAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/agent/banner"), data, {
    method
  });
}

// 代理banner -- banner下架
function bannerAgentNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner/nouser"), data, {
    method
  });
}

// 代理banner -- banner上架
function bannerAgentUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner/user"), data, {
    method
  });
}

// banner管理 -- 房间任务banner列表
function bannerTaskList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/task/banner"), data, {
    method
  });
}

// banner管理 -- 编辑房间任务banner
function bannerTaskEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/task/banner"), data, {
    method
  });
}

// banner管理 -- 添加房间任务banner
function bannerTaskAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/group/task/banner"), data, {
    method
  });
}

// banner管理 -- 房间任务banner 上下架
function bannerTaskSetStatus(data, method) {
  return ajax(
    "put",
    getRequestUrl("/v1/mgr/group/task/banner/setStatus"),
    data,
    {
      method
    }
  );
}

// 查询本人的模块页面
function permissionModule(data, method) {
  return ajax("get", getRequestUrl("/v1/manager/permission/module"), data, {
    method
  });
}

// 表情管理
//  获取列表
function getemoji(data, method) {
  return ajax("get", getRequestUrl("/v1/mic/emoji/page"), data, {
    method
  });
}
//  上下架
function emojiSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/mic/emoji/switch"), data, {
    method
  });
}

//  增加表情
function postEmoji(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/mic/emoji"), data, {
    method
  });
}
//  修改表情
function putEmoji(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/mic/emoji"), data, {
    method
  });
}

//  修改表情
function getCyclestats(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/stats"), data, {
    method
  });
}

//
// 查询群主题
function getGroupTheme(data, method) {
  return ajax("get", getRequestUrl("/v1/groupTheme/"), data, {
    method
  });
}
//
// 查询群主题 上下架
function putGroupThemeSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupTheme/switch"), data, {
    method
  });
}

// 查询群主题 新增
function postGroupTheme(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupTheme"), data, {
    method
  });
}

// 查询群主题 修改
function putGroupTheme(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupTheme"), data, {
    method
  });
}
// 查询-头饰
function getHeadwear(data, method) {
  return ajax("get", getRequestUrl("/v1/headwear/"), data, {
    method
  });
}

//  查询-头饰 修改
function putHeadwear(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear"), data, {
    method
  });
}
//  查询-头饰 新增
function postHeadwear(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/headwear"), data, {
    method
  });
}
//  查询-头饰 上架
function putHeadwearon(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/shop/in"), data, {
    method
  });
}
//  查询-头饰 上架
function putHeadwearout(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/shop/out"), data, {
    method
  });
}
//  查询-头饰 列表 获取所有该用户的道具配置
function getHeadwearUser(data, method) {
  return ajax("get", getRequestUrl(`/v1/headwear/user/${method.id}`), data, {
    method
  });
}

//  查询-头饰 移出
function postHeadwearRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/user/remove"), data, {
    method
  });
}
//  查询-头饰 -添加用户
function postHeadwearUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/headwear/user"), data, {
    method
  });
}

// 查询-勋章
function getMedal(data, method) {
  return ajax("get", getRequestUrl("/v1/medal/"), data, {
    method
  });
}

//  查询-勋章 修改
function putMedal(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/medal"), data, {
    method
  });
}
//  查询-勋章 新增
function postMedal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/medal"), data, {
    method
  });
}
//  查询-勋章 列表 获取所有该用户的道具配置
function getMedalUser(data, method) {
  return ajax("get", getRequestUrl("/v1/medal/user"), data, {
    method
  });
}

//  查询-勋章 移出
function postMedalRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/medal/remove"), data, {
    method
  });
}
//  查询-勋章添加用户
function postMedalUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/medal/add"), data, {
    method
  });
}

// --
// 查询-铭牌
function getNameplate(data, method) {
  return ajax("get", getRequestUrl("/v1/nameplate/"), data, {
    method
  });
}

//  查询-铭牌 修改
function putNameplate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/nameplate"), data, {
    method
  });
}
//  查询-铭牌 新增
function postNameplate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/nameplate"), data, {
    method
  });
}
//  查询-铭牌 列表 查询拥有铭牌的用户
function getNameplateUser(data, method) {
  return ajax("get", getRequestUrl("/v1/nameplate/user"), data, {
    method
  });
}

//  查询-铭牌 移除某个用户的铭牌
function postNameplateRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/nameplate/remove"), data, {
    method
  });
}
//  查询-给用户添加铭牌
function postNameplateUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/nameplate/add"), data, {
    method
  });
}
// --
// 查询-ID装饰框
function getIDOrnament(data, method) {
  return ajax("get", getRequestUrl("/v1/idFrame/"), data, {
    method
  });
}

//  查询-ID装饰框 修改
function putIDOrnament(data, method) {
  return ajax("put", getRequestUrl("/v1/idFrame"), data, {
    method
  });
}
//  查询-ID装饰框 新增
function postIDOrnament(data, method) {
  return ajax("post", getRequestUrl("/v1/idFrame"), data, {
    method
  });
}
//  查询-ID装饰框 列表 查询拥有ID装饰框的用户
function getIDOrnamentUser(data, method) {
  return ajax("get", getRequestUrl("/v1/idFrame/user"), data, {
    method
  });
}

//  查询-ID装饰框 移除某个用户的ID装饰框
function postIDOrnamentRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/idFrame/user"), data, {
    method
  });
}
//  查询-给用户添加ID装饰框
function postIDOrnamentUser(data, method) {
  return ajax("post", getRequestUrl("/v1/idFrame/user"), data, {
    method
  });
}

// --房间标签
// 查询-房间标签
function getRoomLabel(data, method) {
  return ajax("get", getRequestUrl("/v1/groupTab/"), data, {
    method
  });
}

//  查询-房间标签 修改
function putRoomLabel(data, method) {
  return ajax("put", getRequestUrl("/v1/groupTab/"), data, {
    method
  });
}
//  查询-房间标签新增
function postRoomLabel(data, method) {
  return ajax("post", getRequestUrl("/v1/groupTab/"), data, {
    method
  });
}
//  查询-房间标签列表 查询拥有铭牌的用户
function getRoomLabelUser(data, method) {
  return ajax("get", getRequestUrl("/v1/groupTab/user"), data, {
    method
  });
}

//  查询-房间标签移除某个用户的铭牌
function postRoomLabelRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/groupTab/user"), data, {
    method
  });
}
//  查询-给用户添加房间标签
function postRoomLabelUser(data, method) {
  return ajax("post", getRequestUrl("/v1/groupTab/user"), data, {
    method
  });
}
// --
// -- 房间头像框管理
// 查询-房间头像框
function getRoomHeader(data, method) {
  return ajax("get", getRequestUrl("/v1/groupHeadwear/"), data, {
    method
  });
}

//  查询-房间头像框 修改
function putRoomHeader(data, method) {
  return ajax("put", getRequestUrl("/v1/groupHeadwear/"), data, {
    method
  });
}
//  查询-房间头像框 新增
function postRoomHeader(data, method) {
  return ajax("post", getRequestUrl("/v1/groupHeadwear/"), data, {
    method
  });
}
//  查询-房间头像框 列表 查询拥有铭牌的用户
function getRoomHeaderUser(data, method) {
  return ajax("get", getRequestUrl("/v1/groupHeadwear/user"), data, {
    method
  });
}

//  查询-房间头像框 移除某个用户的铭牌
function postRoomHeaderRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/groupHeadwear/user"), data, {
    method
  });
}
//  查询-给用户添加房间头像框
function postRoomHeaderUser(data, method) {
  return ajax("post", getRequestUrl("/v1/groupHeadwear/user"), data, {
    method
  });
}
// --

// -- 用户资料页挂饰管理
// 查询-资料页挂饰
function getUserOrnaments(data, method) {
  return ajax("get", getRequestUrl("/v1/userOrnaments/"), data, {
    method
  });
}

//  查询-资料页挂饰 修改
function putUserOrnaments(data, method) {
  return ajax("put", getRequestUrl("/v1/userOrnaments/"), data, {
    method
  });
}
//  查询-资料页挂饰 新增
function postUserOrnaments(data, method) {
  return ajax("post", getRequestUrl("/v1/userOrnaments/"), data, {
    method
  });
}
//  查询-资料页挂饰 列表 查询拥有挂饰的用户
function getUserOrnamentsUser(data, method) {
  return ajax("get", getRequestUrl("/v1/userOrnaments/user"), data, {
    method
  });
}

//  查询-资料页挂饰 移除某个用户的挂饰
function postUserOrnamentsRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/userOrnaments/user"), data, {
    method
  });
}
//  查询-给用户添加资料页挂饰
function postUserOrnamentsUser(data, method) {
  return ajax("post", getRequestUrl("/v1/userOrnaments/user"), data, {
    method
  });
}
// --

///////////////////////////////////////-皮肤管理-///////////////////////////////////////
// 查询-个人资料弹窗皮肤管理
function getPersonal(data, method) {
  return ajax("get", getRequestUrl("/v1/profilePageSkins/"), data, {
    method
  });
}

//  查询-个人资料弹窗皮肤管理 修改
function putPersonal(data, method) {
  return ajax("put", getRequestUrl("/v1/profilePageSkins/"), data, {
    method
  });
}
//  查询-个人资料弹窗皮肤管理 新增
function postPersonal(data, method) {
  return ajax("post", getRequestUrl("/v1/profilePageSkins/"), data, {
    method
  });
}
//  查询-个人资料弹窗皮肤管理 列表 查询拥有铭牌的用户
function getPersonalUser(data, method) {
  return ajax("get", getRequestUrl("/v1/profilePageSkins/user"), data, {
    method
  });
}

//  查询-个人资料弹窗皮肤管理 移除某个用户的铭牌
function postPersonalRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/profilePageSkins/user"), data, {
    method
  });
}
//  查询-给用户添加--个人资料弹窗皮肤管理
function postPersonalUser(data, method) {
  return ajax("post", getRequestUrl("/v1/profilePageSkins/user"), data, {
    method
  });
}
// --
// 查询-进场尾灯管理
function getTaillight(data, method) {
  return ajax("get", getRequestUrl("/v1/roomTaillightSkins/"), data, {
    method
  });
}

//  查询-进场尾灯管理 修改
function putTaillight(data, method) {
  return ajax("put", getRequestUrl("/v1/roomTaillightSkins/"), data, {
    method
  });
}
//  查询-进场尾灯管理 新增
function postTaillight(data, method) {
  return ajax("post", getRequestUrl("/v1/roomTaillightSkins/"), data, {
    method
  });
}
//  查询-进场尾灯管理 列表 查询拥有铭牌的用户
function getTaillightUser(data, method) {
  return ajax("get", getRequestUrl("/v1/roomTaillightSkins/user"), data, {
    method
  });
}

//  查询-进场尾灯管理 移除某个用户的铭牌
function postTaillightRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/roomTaillightSkins/user"), data, {
    method
  });
}
//  查询-给用户添加--进场尾灯管理
function postTaillightUser(data, method) {
  return ajax("post", getRequestUrl("/v1/roomTaillightSkins/user"), data, {
    method
  });
}
// --
// 查询-麦位光波管理
function getMicrophone(data, method) {
  return ajax("get", getRequestUrl("/v1/micWaveSkins/"), data, {
    method
  });
}

//  查询-麦位光波管理 修改
function putMicrophone(data, method) {
  return ajax("put", getRequestUrl("/v1/micWaveSkins/"), data, {
    method
  });
}
//  查询-麦位光波管理 新增
function postMicrophone(data, method) {
  return ajax("post", getRequestUrl("/v1/micWaveSkins/"), data, {
    method
  });
}
//  查询-麦位光波管理 列表 查询拥有铭牌的用户
function getMicrophoneUser(data, method) {
  return ajax("get", getRequestUrl("/v1/micWaveSkins/user"), data, {
    method
  });
}

//  查询-麦位光波管理 移除某个用户的铭牌
function postMicrophoneRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/micWaveSkins/user"), data, {
    method
  });
}
//  查询-给用户添加--麦位光波管理
function postMicrophoneUser(data, method) {
  return ajax("post", getRequestUrl("/v1/micWaveSkins/user"), data, {
    method
  });
}
// --
// 查询-房间气泡框管理
function getBubbleBox(data, method) {
  return ajax("get", getRequestUrl("/v1/roomChatBubbleSkins/"), data, {
    method
  });
}

//  查询-房间气泡框管理 修改
function putBubbleBox(data, method) {
  return ajax("put", getRequestUrl("/v1/roomChatBubbleSkins/"), data, {
    method
  });
}
//  查询-房间气泡框管理 新增
function postBubbleBox(data, method) {
  return ajax("post", getRequestUrl("/v1/roomChatBubbleSkins/"), data, {
    method
  });
}
//  查询-房间气泡框管理 列表 查询拥有铭牌的用户
function getBubbleBoxUser(data, method) {
  return ajax("get", getRequestUrl("/v1/roomChatBubbleSkins/user"), data, {
    method
  });
}

//  查询-房间气泡框管理 移除某个用户的铭牌
function postBubbleBoxRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/roomChatBubbleSkins/user"), data, {
    method
  });
}
//  查询-给用户添加--房间气泡框管理
function postBubbleBoxUser(data, method) {
  return ajax("post", getRequestUrl("/v1/roomChatBubbleSkins/user"), data, {
    method
  });
}
// --
///////////////////////////////////////-皮肤管理-///////////////////////////////////////

//  公会用户管理-扣除豆子
function postBeanReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/bean/reduce"), data, {
    method
  });
}

//  公会用户管理-扣除金币记录
function getGuildUserGold(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/gold"), data, {
    method
  });
}

//  公会用户管理-扣除豆子记录
function getGuildUserBean(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/bean"), data, {
    method
  });
}

//  用户信息管理-修改用户头像
function putUserAvatar(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/avatar"), data, {
    method
  });
}
//  用户信息管理-修改用户头像--限制修改
function putEditAvatarCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/editAvatarCd"), data, {
    method
  });
}
//  用户信息管理-修改用户头像--解除--限制修改
function deleteAvatarCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/editAvatarCd/${data.userId}`),
    data,
    {
      method
    }
  );
}
//  用户信息管理-修改用户昵称--限制修改
function putEditNickCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/editNickCd"), data, {
    method
  });
}
//  用户信息管理-修改用户昵称--解除--限制修改
function deleteNickCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/editNickCd/${data.userId}`),
    data,
    {
      method
    }
  );
}
//  用户信息管理-修改用户相册--限制修改
function putEditPhotoCd(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/editPhotoCd"), data, {
    method
  });
}
//  用户信息管理-修改用户相册--解除--限制修改
function deletePhotoCd(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/editPhotoCd/${data.userId}`),
    data,
    {
      method
    }
  );
}
//  用户信息管理-修改用户国家
function putUserCountry(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/country"), data, {
    method
  });
}

//  用户信息管理-ip
function getIpSame(data, method) {
  return ajax("get", getRequestUrl("/v1/user/ip/same"), data, {
    method
  });
}
//  ip账号统计
function getIpStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/user/ip/same/cnt"), data, {
    method
  });
}
//  用户信息管理-同设备账号数
function getImeiSame(data, method) {
  return ajax("get", getRequestUrl("/v1/user/imei/same"), data, {
    method
  });
}
//  imei账号统计
function getImeiStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/user/imei/same/cnt"), data, {
    method
  });
}

//  用户信息管理-豆子收入明细
function getUserIncome(data, method) {
  return ajax("get", getRequestUrl("/v1/user/income"), data, {
    method
  });
}

//  用户信息管理-ip-冻结全部
function postUserIpDeal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/ip/deal"), data, {
    method
  });
}

//  用户信息管理-设备-冻结全部
function postUserImeipDeal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/imei/deal"), data, {
    method
  });
}

//  用户信息管理-钻石冻结
function putCcountFrozen(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/account/frozen"), data, {
    method
  });
}

//  用户信息管理-钻石解冻
function putCcountNormal(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/account/normal"), data, {
    method
  });
}

//  群组支持-查询群组支持详情
function getGroupSupport(data, method) {
  return ajax("get", getRequestUrl("/v1/groupSupport/detail"), data, {
    method
  });
}

//  群组支持-查询群组支持统计
function getGroupSupportStats(data, method) {
  return ajax("get", getRequestUrl("/v1/groupSupport/stats"), data, {
    method
  });
}

// 女孩扶持--数据查询
function getGirlList(data, method) {
  return ajax("get", getRequestUrl("/v1/girlSupport/page"), data, {
    method
  });
}
// 女孩扶持--获取审核列表
function getAuditList(data, method) {
  return ajax("get", getRequestUrl("/v1/girlSupport/audit"), data, {
    method
  });
}
// 女孩扶持--审核
function getAuditOperation(data, method) {
  return ajax("post", getRequestUrl("/v1/girlSupport/audit"), data, {
    method
  });
}

//  钻石发放-查询记录
function getBillpage(data, method) {
  return ajax("get", getRequestUrl("/v1/diamond/bill/page"), data, {
    method
  });
}
// 钻石发放-上传文件
function uploadDiamondbill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/diamond/bill"), data);
}
// 钻石发放-确认发放
function putDiamondbill(data) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/bill"), data);
}

//  游戏币发放-查询记录
function getYXBPage(data, method) {
  return ajax("get", getRequestUrl("/v1/diamondPink/bill/page"), data, {
    method
  });
}
// 游戏币发放-上传文件
function uploadGameBill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/diamondPink/bill"), data);
}
// 游戏币发放-确认发放
function putGameBill(data) {
  return ajax("put", getRequestUrl("/v1/mgr/diamondPink/bill"), data);
}
//  贵族发放-查询记录
function getBatchPage(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/noble/user/batch"), data, {
    method
  });
}
// 贵族发放-上传文件
function uploadDiamondBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/noble/user/batch"), data);
}

// 贵族发放-确认发放
function putDiamondBatch(data) {
  return ajax("put", getRequestUrl("/v1/mgr/noble/user/batch"), data);
}

//  道具发放-查询记录
function getPropsPage(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/user/bag/send/batch"), data, {
    method
  });
}
// 道具发放-上传文件
function uploadPropsBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/user/bag/send/batch"), data);
}

// 道具发放-确认发放
function putPropsBatch(data) {
  return ajax("put", getRequestUrl("/v1/mgr/user/bag/send/batch"), data);
}

// 代理黄钻-上传文件
function uploadPropsBatchY(data) {
  return uploadImg(getRequestUrl("/v1/mgr/dealer/diamond/batch"), data);
}

// 代理黄钻-确认发放
function putPropsBatchY(data) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/diamond/batch"), data);
}

//  SVIP发放--修改等级--查询记录
function getSvipPage(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/user/svip/batchUpdate/page"),
    data,
    {
      method
    }
  );
}
// SVIP发放--修改等级--上传文件
function uploadSvipbill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/user/svip/batchUpdate"), data);
}
// SVIP发放--修改等级--确认发放
function putSvipbill(data) {
  return ajax("put", getRequestUrl("/v1/mgr/user/svip/batchUpdate"), data);
}

//  SVIP发放--增加积分--查询记录
function getPointsPage(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/user/svip/points/batchUpdate/page"),
    data,
    {
      method
    }
  );
}
// SVIP发放--增加积分--上传文件
function uploadPointsbill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/user/svip/points/batchUpdate"), data);
}
// SVIP发放--增加积分--确认发放
function putPointsbill(data) {
  return ajax(
    "put",
    getRequestUrl("/v1/mgr/user/svip/points/batchUpdate"),
    data
  );
}

// 推广员-上传文件
function uploadPromotionBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/promotion/invite/batch"), data);
}

//  综合奖励发放--任务列表
function getawardTask(data, method) {
  return ajax("get", getRequestUrl("/v1/awardTask/"), data, {
    method
  });
}
//  综合奖励发放--任务新增
function postAwardTask(data, method) {
  return ajax("post", getRequestUrl("/v1/awardTask/"), data, {
    method
  });
}
//  综合奖励发放--任务修改
function putAwardTask(data, method) {
  return ajax("put", getRequestUrl("/v1/awardTask/"), data, {
    method
  });
}
//  综合奖励发放--任务删除
function deleteAwardTask(data, method) {
  return ajax("delete", getRequestUrl(`/v1/awardTask/del/${data.id}`), data, {
    method
  });
}
//  综合奖励发放--奖励配置--列表
function getawardConfigTask(data, method) {
  return ajax("get", getRequestUrl("/v1/awardTask/config"), data, {
    method
  });
}
//  综合奖励发放--奖励配置--新增
function postAwardConfigTask(data, method) {
  return ajax("post", getRequestUrl("/v1/awardTask/config"), data, {
    method
  });
}
//  综合奖励发放--奖励配置--修改
function putAwardConfigTask(data, method) {
  return ajax("put", getRequestUrl("/v1/awardTask/config"), data, {
    method
  });
}
//  综合奖励发放--奖励配置--删除
function deleteAwardConfigTask(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/awardTask/config/${data.id}`),
    data,
    {
      method
    }
  );
}
//  综合奖励发放--发放奖励--列表
function getdistributionTask(data, method) {
  return ajax("get", getRequestUrl("/v1/awardTask/distribution"), data, {
    method
  });
}
//  综合奖励发放--发放奖励--批量上传用户code
function putCodeAllBill(data) {
  // return ajax("post", getRequestUrl("/v1/awardTask/batchDistribution"), data, {
  //   method
  // });
  return uploadImg(getRequestUrl("/v1/awardTask/batchDistribution"), data);
}
//  综合奖励发放--发放奖励--确认发放（批量）
function putAwardBill(data, method) {
  return ajax("put", getRequestUrl("/v1/awardTask/batchDistribution"), data, {
    method
  });
}
//  综合奖励发放--发放奖励--确认发放（单个）
function putAwardOneBill(data, method) {
  return ajax("post", getRequestUrl("/v1/awardTask/distribution"), data, {
    method
  });
}

//  国家管理-查询记录
function getGrouppowerpage(data, method) {
  return ajax("get", getRequestUrl("/v1/groupPower/page"), data, {
    method
  });
}

//  国家管理-新增
function postGrouppower(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower"), data, {
    method
  });
}
//  国家管理-修改
function putGrouppower(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupPower"), data, {
    method
  });
}
//  国家管理-查询记录
function putgroupPowerStatus(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupPower/status"), data, {
    method
  });
}
// 国家管理-国家势力解散
function postDissolve(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower/dissolve"), data, {
    method
  });
}

//  设备-增加设备限制
function postImei(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/imei"), data, {
    method
  });
}

//  设备-删除设备限制
function deleteImei(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/imei/${method.imei}`), data, {
    method
  });
}

//  查询-道具 上架
function putPropertyon(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/property/shop/in"), data, {
    method
  });
}
//  查询-道具 上架
function putPropertyout(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/property/shop/out"), data, {
    method
  });
}

// 发现页banner

// banner管理 -- banner列表
function bannerDiscovery(data, method) {
  return ajax("get", getRequestUrl("/v1/discovery/banner/page"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerDiscoveryEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerDiscoveryAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/discovery/banner"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerDiscoveryNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner/nouser"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerDiscoveryUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner/user"), data, {
    method
  });
}

// 游戏中心banner

// banner管理 -- banner列表
function bannerGame(data, method) {
  return ajax("get", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerGameEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerGameAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerGameNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerGameUse(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// 闪屏（接口是：开屏）

// 广告管理 -- 闪屏列表
function openFlashScreen(data, method) {
  return ajax("get", getRequestUrl("/v1/openScreen/page"), data, {
    method
  });
}
// 广告管理 -- 闪屏编辑
function openEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/openScreen"), data, {
    method
  });
}

// 广告管理 -- 闪屏添加
function openAdd(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen"), data, {
    method
  });
}

// 广告管理 -- 闪屏下架
function openNouser(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen/nouse"), data, {
    method
  });
}

// 广告管理 -- 闪屏上架
function openUse(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen/use"), data, {
    method
  });
}

// 运营弹窗（接口是：闪屏）

// 广告管理 -- 运营弹窗列表
function advertisingFlashScreen(data, method) {
  return ajax("get", getRequestUrl("/v1/splashScreen/page"), data, {
    method
  });
}
// 广告管理 -- 运营弹窗编辑
function advertisingEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/splashScreen"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗添加
function advertisingAdd(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗下架
function advertisingNouser(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen/nouse"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗上架
function advertisingUse(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen/use"), data, {
    method
  });
}

// 新用户邀请审核
// 新用户邀请审核 -- 新用户活动奖励（批量通过或拒绝）
function newUserInvite(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/activity/newUserInvite"), data, {
    method
  });
}
// 新用户邀请审核 -- 用户邀请列表
function newUserList(data, method) {
  return ajax("get", getRequestUrl("/v1/newUserActivity/invite/list"), data, {
    method
  });
}
// 新用户邀请审核 -- 邀请结果统计
function resultStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/newUserActivity/invite/stats/${data.period}`),
    data,
    {
      method
    }
  );
}
// 新用户邀请审核 -- 邀请通过统计
function newUserStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/newUserActivity/invite/summary/${data.period}`),
    data,
    {
      method
    }
  );
}
// 新用户邀请审核 -- 用户审核状态列表
function newUserState(data, method) {
  return ajax("get", getRequestUrl("/v1/newUserActivity/list"), data, {
    method
  });
}

// 群组活动奖励审核
// 群组活动奖励审核 -- 群组活动奖励（批量通过或拒绝）
function newGroupInvite(data, method) {
  return ajax("PUT", getRequestUrl("/v1/mgr/group/activity"), data, {
    method
  });
}
function groupAuditList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/activity"), data, {
    method
  });
}
// 群组活动统计
function groupAuditStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/group/activity/stat"), data, {
    method
  });
}

// 金币数据统计
function goldList(data, method) {
  return ajax("get", getRequestUrl(`/v1/gold/sum/${data.period}`), data, {
    method
  });
}

// 充值代理管理 -- 新增促销员
function selectPromoter(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/mgr/dl/promoter/${data.userId}`),
    data,
    {
      method
    }
  );
}
// 充值代理管理 -- 编辑促销员
function editPromoter(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dl/promoter"), data, {
    method
  });
}

// 充值代理管理 -- 查询币商信息
function dealerList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/"), data, {
    method
  });
}
// 充值代理管理 -- 黄钻销售记录编辑调用-币商列表-把原来的dealerList区分开
function editDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/detail"), data, {
    method
  });
}

// 充值代理管理 -- 冻结/解冻币商
function frozenFu(data, method) {
  return ajax("post", getRequestUrl("/v1/dealer/frozen"), data, {
    method
  });
}
// 用户 -- 国家列表
function getDealerCountryList(data, method, aa) {
  return ajax("get", getRequestUrl("/v1/user/country", aa), data, {
    method
  });
}
// 充值代理管理 -- 查询币商充值记录
function dealerChargeList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/charge"), data, {
    method
  });
}
// 充值代理管理 -- 查询币商小结（黄钻销售记录）
function dealerSummaryList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/summary"), data, {
    method
  });
}
// 充值代理管理 -- 销售明细
function detailList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/transfer"), data, {
    method
  });
}
// 充值代理管理 -- 分销明细
function distributionDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/shift/list"), data, {
    method
  });
}
// 充值代理管理 -- 新增代理
function agentCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer"), data, {
    method
  });
}
// 充值代理管理 -- 编辑代理
function agentCreateEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer"), data, {
    method
  });
}
// 充值代理管理 -- 代理修改（接口暂缺）
// function agentUpdate(data, method) {
//   return ajax('put', getRequestUrl('/v1/mgr/gift/edit'), data, {
//     method,
//   });
// }
// 充值代理管理 -- 代理下架
function agentSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/status"), data, {
    method
  });
}
// 充值代理管理 -- 代理充值
function agentCurrency(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer/diamond"), data, {
    method
  });
}
// 充值代理管理 -- 币商上架到国家(新增)
function countrySave(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/country"), data, {
    method
  });
}
// 充值代理管理 -- 查询币商上架到哪些国家(编辑)
function countryList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/country"), data, {
    method
  });
}

// 充值代理管理 -- 二级代理列表
function secondList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/second"), data, {
    method
  });
}
// 充值代理管理 -- 二级代理（创建）
function secondAddOrEdit(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer/second"), data, {
    method
  });
}
// 充值代理管理 -- 二级代理（编辑）
function secondOrEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/second"), data, {
    method
  });
}
// 充值代理管理 -- 扣除代理货币明细列表
function deductListDG(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/diamond/deduct/list"), data, {
    method
  });
}
// 充值代理管理 -- 扣除代理[钻石、金币]
function deductDGOrEdit(data, method) {
  return ajax("post", getRequestUrl("/v1/dealer/diamond/deduct"), data, {
    method
  });
}

// 活动管理 -- 周星活动 -- 列表
function giftList(data, method) {
  return ajax("get", getRequestUrl("/v1/weeklyGift/"), data, {
    method
  });
}
// 活动管理 -- 周星活动 -- 新增/修改
function weekGiftCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/weeklyStarGift"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 奖励列表
function getPrizePage(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 抽奖统计
function getPrizeDraw(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/count/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 抽奖明细
function getPrizeDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/detail/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 编辑奖品
function getPrizeEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 添加奖品
function getPrizeAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/luckybox/award"), data, {
    method
  });
}

//  玩法管理 -- 幸运盒子 上架
function prizeUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award/use"), data, {
    method
  });
}
//  玩法管理 -- 幸运盒子 下架
function prizeUseNo(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award/useno"), data, {
    method
  });
}

// ---------------------------
// 玩法管理 -- H5幸运盒子 -- 高级奖励列表
function getPrizePageH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级抽奖统计
function getPrizeDrawH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/count/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级抽奖明细
function getPrizeDetailH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/detail/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级编辑奖品
function getPrizeEditH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级添加奖品
function getPrizeAddH5(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/luckybox/h5/award"), data, {
    method
  });
}

//  玩法管理  -- H5幸运盒子 -- 高级上架
function prizeUseH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award/use"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 -- 高级下架
function prizeUseNoH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award/useno"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 奖励榜单
function boxAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/rank/award"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 投注榜单
function boxStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/rank/stake"), data, {
    method
  });
}
// ---------------------------

//  活动管理 -- 群组对战 查询群组PK
function groupPKList(data, method) {
  return ajax("get", getRequestUrl("/v1/activity/groupPK/page"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK详情
function groupPKDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/activity/groupPK/detail/page"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-删除PK组
function groupPKDel(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/del"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-更新PK组
function groupPKUpdate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/activity/pk/group"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-增加PK组
function groupPKAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/group"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-上架
function pkUse(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/use"), data, {
    method
  });
}
//  活动管理 -- 群组对战 群组PK活动-下架
function pkUseNo(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/nouse"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动奖励
function groupPKAward(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/group/award"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-增加PK组excel
function groupPKExcel(data, method) {
  return uploadImg(getRequestUrl("/v1/mgr/activity/pk/group/excel"), data);
}

//  玩法管理 -- 水果机 日统计
function statisticsList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 水果机 日明细
function dayDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/day/detail"), data, {
    method
  });
}
//  玩法管理 -- 水果机--用户明细 奖励榜单
function dayAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 水果机--用户明细 投注榜单
function dayStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 水果机 利润榜单-升序
function gameFruitsAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 -- 水果机 利润榜单-降序
function gameFruitsDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/profit/desc"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-列表
function gameFruitsScriptList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/script/list"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-执行列表
function gameFruitsScriptExecList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/script/exec/list"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-添加脚本
function getAddFruitsScript(data, method) {
  return ajax("POST", getRequestUrl("/v1/fruitMachine/script"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-删除脚本
function getDeleteFruitsScript(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/fruitMachine/script/${data.id}`),
    data,
    {
      method
    }
  );
}

//  玩法管理 -- 幸运礼物 日统计
function rebateGiftList(data, method) {
  return ajax("get", getRequestUrl("/v1/rebateGift/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 幸运礼物 日统计-手动计算（用不到）
// function dayGiftDetailList(data, method) {
//   return ajax("get", getRequestUrl("/v1/rebateGift/day/stats/manual"), data, {
//     method
//   });
// }
//  玩法管理 -- 幸运礼物--用户明细 奖励榜单
function dayGiftAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/rebateGift/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 幸运礼物--用户明细 投注榜单
function dayGiftStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/rebateGift/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 幸运礼物 利润榜单-升序
function gameGiftAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/rebateGift/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 -- 幸运礼物 利润榜单-降序
function gameGiftDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/rebateGift/rank/profit/desc"), data, {
    method
  });
}

//  玩法管理 -- 足球游戏 日统计 Football
function footballList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/day/stats"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏 日明细
function dayDetailFootballList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/day/detail"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏--用户明细 奖励榜单
function dayAwardFootballList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/rank/award"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏--用户明细 投注榜单
function dayStakeFootballList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/rank/stake"),
    data,
    {
      method
    }
  );
}

//  玩法管理 -- 足球游戏 利润榜单-升序
function gameFootballAsc(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/rank/profit/asc"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏 利润榜单-降序
function gameFootballDesc(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/rank/profit/desc"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏 脚本管理-列表
function gameFootballScriptList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/script/list"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏 脚本管理-执行列表
function gameFootballScriptExecList(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/football/fruitMachine/script/exec/list"),
    data,
    {
      method
    }
  );
}
//  玩法管理 -- 足球游戏 脚本管理-添加脚本
function getAddFootballScript(data, method) {
  return ajax("POST", getRequestUrl("/v1/football/fruitMachine/script"), data, {
    method
  });
}
//  玩法管理 -- 足球游戏 脚本管理-删除脚本
function getDeleteFootballScript(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/football/fruitMachine/script/${data.id}`),
    data,
    {
      method
    }
  );
}

//  玩法管理 -- slot榜单 奖励榜单
function slotAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/slot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- slot榜单 投注榜单
function slotStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/slot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- candy榜单 奖励榜单
function candyAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/candy/rank/award"), data, {
    method
  });
}
//  玩法管理 -- candy榜单 投注榜单
function candyStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/candy/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- greedy榜单 奖励榜单
function greedyAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/greedy/rank/award"), data, {
    method
  });
}
//  玩法管理 -- greedy榜单 投注榜单
function greedyStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/greedy/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 多财多福榜单 日统计
function gameSlotDayList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 多财多福榜单 奖励榜单
function gameSlotAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 多财多福榜单 投注榜单
function gameSlotStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 赛车游戏 日统计
function statisticsRaceList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 日明细
function dayRaceDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/day/detail"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 奖励榜单
function gameRaceAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 投注榜单
function gameRaceStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/stake"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 利润榜单-升序
function gameRaceStakeAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 利润榜单-降序
function gameRaceStakeDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/profit/desc"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-列表
function gameRaceScriptList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/script/list"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-执行列表
function gameRaceScriptExecList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/script/exec/list"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-添加脚本
function getAddScript(data, method) {
  return ajax("POST", getRequestUrl("/v1/race/script"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-删除脚本
function getDeleteScript(data, method) {
  return ajax("delete", getRequestUrl(`/v1/race/script/${data.id}`), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 日统计
function statisticsEgyptList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 奖励榜单
function EgyptAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 投注榜单
function EgyptStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 捕鱼游戏 日统计
function statisticsFishList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 捕鱼游戏 奖励榜单
function FishAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 捕鱼游戏 投注榜单
function FishStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 足球slot 日统计
function statisticsFootballList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 足球slot 奖励榜单
function FootballAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 足球slot 投注榜单
function FootballStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/rank/stake"), data, {
    method
  });
}

/////////////////////////////////////
//  玩法管理 -- 女巫slot 日统计
function statisticsWitchList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 女巫slot 奖励榜单
function WitchAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 女巫slot 投注榜单
function WitchStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- teenparty 日统计
function statisticsTeenpList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/day/stats"), data, {
    method
  });
}
//  玩法管理 -- teenparty 奖励榜单
function TeenpAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/rank/award"), data, {
    method
  });
}
//  玩法管理 -- teenparty 投注榜单
function TeenpStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/rank/stake"), data, {
    method
  });
}
//////////////////////////////////////////////////
//  玩法管理 --  foodie游戏 日统计
function statisticsFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/day/stats"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 日明细
function dayDetailFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/day/detail"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏--用户明细 奖励榜单
function dayAwardFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/award"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏--用户明细 投注榜单
function dayStakeFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/stake"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 利润榜单-升序
function gameFoodieAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 利润榜单-降序
function gameFoodieDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/profit/desc"), data, {
    method
  });
}
//////////////////////////////////////////////////
//////////////////////////////////////////////////
//  玩法管理 --  猫猫-- foodie游戏 日统计
function statisticsCatFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/day/stats"), data, {
    method
  });
}
//  玩法管理 --  猫猫-- foodie游戏 日明细
function dayDetailCatFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/day/detail"), data, {
    method
  });
}
//  玩法管理 --  猫猫-- foodie游戏--用户明细 奖励榜单
function dayAwardCatFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/rank/award"), data, {
    method
  });
}
//  玩法管理 --  猫猫-- foodie游戏--用户明细 投注榜单
function dayStakeCatFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/rank/stake"), data, {
    method
  });
}
//  玩法管理 --  猫猫-- foodie游戏 利润榜单-升序
function gameCatFoodieAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 --  猫猫-- foodie游戏 利润榜单-降序
function gameCatFoodieDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/catFoodie/rank/profit/desc"), data, {
    method
  });
}
//////////////////////////////////////////////////
//////////////////////////////////////////////////
//  玩法管理 --  delicious游戏 日统计--Delicious
function statisticsdDeliciousList(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/day/stats"), data, {
    method
  });
}
//  玩法管理 --  delicious游戏 日明细
function dayDetailDeliciousList(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/day/detail"), data, {
    method
  });
}
//  玩法管理 --  delicious游戏--用户明细 奖励榜单
function dayAwardDeliciousList(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/rank/award"), data, {
    method
  });
}
//  玩法管理 --  delicious游戏--用户明细 投注榜单
function dayStakeDeliciousList(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/rank/stake"), data, {
    method
  });
}
//  玩法管理 --  delicious游戏 利润榜单-升序
function gameDeliciousAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 --  delicious游戏 利润榜单-降序
function gameDeliciousDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/delicious/rank/profit/desc"), data, {
    method
  });
}
//////////////////////////////////////////////////

//  活动管理 -- 水果大亨统计
function bigwigList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/tycoon/stats"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 查询活动1
function getTemplateAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actRecord/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 添加活动1
function getAddTemplateAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actRecord"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 编辑活动1
function getEditTemplateAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actRecord"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 删除活动1
function delTemplateAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/actMgr/actRecord/${data.id}`),
    data,
    {
      method
    }
  );
}
//  活动管理 -- 活动配置 -- 复制活动1
function getCopyAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actRecord/copy"), data, {
    method
  });
}
// 活动管理 -- 活动配置 -- 活动礼物列表1
function getGiftAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actGift/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 活动礼物编辑1
function getUpdateGiftAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actGift/config/"), data, {
    method
  });
}

//  活动管理 -- 活动配置 -- 查询活动任务1
function getTaskAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actTask/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 添加任务1
function getAddTaskAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actTask/config/"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 编辑任务1
function getEditTaskAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actTask/config/"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 删除任务1
function delTaskAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/actMgr/actTask/config/${data.activityId}/${data.taskId}`
    ),
    data,
    {
      method
    }
  );
}
//  活动管理 -- 活动配置 -- 复制任务1
function getCopyTaskAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actTask/config/copy"), data, {
    method
  });
}

//  活动管理 -- 活动配置 -- 任务 -- 奖励1
function getAwardAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actAward/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置  -- 任务 -- 添加奖励1
function getAddAwardAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actAward/config"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 任务  -- 编辑奖励1
function getEditAwardAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actAward/config"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 任务  -- 删除奖励1
function delAwardAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/actMgr/actAward/config/${data.activityId}/${data.taskId}/${data.n}`
    ),
    data,
    {
      method
    }
  );
}

// 活动管理 -- 选手名单 -- 上传选手名单1
function uploadTeamUser(data) {
  return uploadImg(getRequestUrl("/v1/actMgr/actTeam/user/excelCreate"), data);
}
// 活动管理 -- 选手名单 -- 获取活动队伍1
function getTeamUser(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actTeam/user/list"), data, {
    method
  });
}
// 活动管理 -- 选手名单 -- 修改活动队伍1
function putTeamUser(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actTeam/user"), data, {
    method
  });
}
// 活动管理 -- 选手名单 -- 名单下载1
function downloadRank(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actRank/list"), data, {
    method
  });
}

// 活动管理 -- 活动补票 -- 列表【/v1/templateAct/sendBallot】
function getListAct(data, method) {
  return ajax("get", getRequestUrl("/v1/templateAct/sendBallot"), data, {
    method
  });
}
// 活动管理 -- 活动补票 -- 确认补票【/v1/templateAct/sendBallot】
function getMendAct(data, method) {
  return ajax("post", getRequestUrl("/v1/templateAct/sendBallot"), data, {
    method
  });
}

// 活动管理 -- 活动重启 -- 列表【/v1/actMgr/gameAct [get]】
function getRebList(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/gameAct"), data, {
    method
  });
}
// 活动管理 -- 活动重启 -- 创建【/v1/actMgr/gameAct[post]】
function getRebAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/gameAct"), data, {
    method
  });
}
// 活动管理 -- 活动重启 -- 编辑【/v1/actMgr/gameAct [put]】
function getRebEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/gameAct"), data, {
    method
  });
}
// 活动管理 -- 活动重启 -- 复制【/v1/actMgr/gameAct/copy [post]】
function getRebCopy(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/gameAct/copy"), data, {
    method
  });
}
// 活动管理 -- 活动重启 -- 删除【/v1/actMgr/gameAct/:actType/:id [DELETE]】
function getRebDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/actMgr/gameAct/${data.actType}/${data.id}`),
    data,
    {
      method
    }
  );
}

// 活动管理 -- 弹窗活动 -- 列表【/v1/actMgr/actPopup/list [get]】
function getPopupList(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actPopup/list"), data, {
    method
  });
}
// 活动管理 -- 弹窗活动 -- 创建【/v1/actMgr/actPopup [post]】
function getPopupAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actPopup"), data, {
    method
  });
}
// 活动管理 -- 弹窗活动 -- 编辑【/v1/actMgr/actPopup [put]】
function getPopupEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actPopup"), data, {
    method
  });
}
// 活动管理 -- 弹窗活动 -- 复制【/v1/actMgr/gameAct/copy [post]】
// function getPopupCopy(data, method) {
//   return ajax("post", getRequestUrl("/v1/actMgr/gameAct/copy"), data, {
//     method
//   });
// }
// 活动管理 -- 弹窗活动 -- 删除【/v1/actMgr/gameAct/:actType/:id [DELETE]】
function getPopupDel(data, method) {
  return ajax("delete", getRequestUrl(`/v1/actMgr/actPopup/${data.id}`), data, {
    method
  });
}

// 活动管理 --转盘配置 -- 新增配置
function getTurntableAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/turntable/info"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 编辑配置
function getTurntablePut(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/turntable/info"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 删除配置
function getTurntableDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/turntable/info/${data.id}`),
    data,
    {
      method
    }
  );
}
// 活动管理 --转盘配置 -- 复制配置
function getCopyTurn(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/turntable/copy"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 列表
function getTurntableList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/turntable/info"), data, {
    method
  });
}

// 活动管理 --转盘配置 -- 新增奖品配置
function getTurnAwardAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/turntable/conf"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 编辑奖品配置
function getTurnAwardPut(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/turntable/conf"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 删除奖品配置
function getTurnAwardDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/turntable/conf/${data.id}`),
    data,
    {
      method
    }
  );
}
// 活动管理 --转盘配置 -- 奖品配置列表
function getTurnAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/turntable/conf"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 抽奖统计列表
function getTurnStatisticsList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/turntable/stat"), data, {
    method
  });
}
// 活动管理 --转盘配置 -- 奖品明细列表
function getTurnDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/turntable/award/detail"), data, {
    method
  });
}

//  用户充值管理 -- 列表
function getUserRecharge(data, method) {
  return ajax("get", getRequestUrl("/v1/stats/charge/user"), data, {
    method
  });
}
//  用户充值管理 -- 累充用户数据
function amassUser(data, method) {
  return ajax("get", getRequestUrl("/v1/export/charge/sum"), data, {
    method
  });
}
//  用户充值管理 -- SVIP用户数据
function amassUserSvip(data, method) {
  return ajax("get", getRequestUrl("/v1/export/svip/data"), data, {
    method
  });
}

// 风险管理--退款明细
function refundDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/refund/detail"), data, {
    method
  });
}
// 风险管理--充值黑白名单
function whiteBlackDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--新增
function whiteBlackAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--编辑
function whiteBlackEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--删除
function delRollAct(data, method) {
  return ajax("delete", getRequestUrl(`/v1/risk/whiteBlack/${data.id}`), data, {
    method
  });
}
// 风险管理--退款统计
function refundSummary(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/risk/refund/summary/${data.period}`),
    data,
    {
      method
    }
  );
}

// 风险管理--设备黑名单管理
function checkDeviceList(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/black/imei"), data, {
    method
  });
}
// 风险管理--设备黑名单管理--新增
function deviceAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/risk/black/imei"), data, {
    method
  });
}
// 风险管理--设备黑名单管理--编辑
// function deviceEdit(data, method) {
//   return ajax("put", getRequestUrl("/v1/risk/black/imei"), data, {
//     method
//   });
// }
// 风险管理--设备黑名单管理--删除
function delDevice(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/risk/black/imei/${data.imei}`),
    data,
    {
      method
    }
  );
}

// 风险管理--IP黑名单管理
function checkIpList(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/black/ip"), data, {
    method
  });
}
// 风险管理--IP黑名单管理--新增
function IpAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/risk/black/ip"), data, {
    method
  });
}
// 风险管理--IP黑名单管理--编辑
// function IpEdit(data, method) {
//   return ajax("put", getRequestUrl("/v1/risk/black/imei"), data, {
//     method
//   });
// }
// 风险管理--IP黑名单管理--删除
function delIp(data, method) {
  return ajax("delete", getRequestUrl(`/v1/risk/black/ip/${data.ip}`), data, {
    method
  });
}
// 推广管理 -- 30天内充值为0的团队(仅限30天前创建的团队)--清理检查
function teamsRemove(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/promotion/teams/clearCheck"),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 30天内充值为0的团队(仅限30天前创建的团队)--清理确认
function teamsRemoveSure(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/teams/clear"), data, {
    method
  });
}
// 推广管理 -- 30天内邀请充值为0的推广员(仅针对30天前加入)--清理检查
function agentsRemove(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/promotion/agents/clearCheck"),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 30天内邀请充值为0的推广员(仅针对30天前加入)--清理确认
function agentsRemoveSure(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/agents/clear"), data, {
    method
  });
}

// 推广管理 -- 团队统计列表
function getTeamList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/teams/data"), data, {
    method
  });
}
// 推广管理 -- 推广员统计列表
function getAgentsList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/agents/data"), data, {
    method
  });
}

// 推广管理 -- 解散团队
function getDeleteTeam(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/promotion/team/${data.id}`),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 修改经理ID
function amendIDFun(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/promotion/changeManager"), data, {
    method
  });
}
// 推广管理 -- 获取团队信息
function getSelectList(data, method) {
  return ajax("get", getRequestUrl(`/v1/mgr/promotion/team/${data.id}`), data, {
    method
  });
}
//  推广管理 --- 新增团队
function addTeam(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/team"), data, {
    method
  });
}
//  推广管理 --- 编辑团队
function editTeam(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/promotion/team"), data, {
    method
  });
}
//  推广管理 --- 推送欢迎派对小助手 -- 参数：id：推广id，type：0取消，1推送
function pushMsgTeam(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/pushMsg"), data, {
    method
  });
}

// 推广管理 -- 推广团队管理--推广数据--编辑列表--250805
function editDataList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/agents/data2"), data, {
    method
  });
}
// 推广管理 -- 推广团队管理--推广数据--新增单个推广员--250805
function addExtendOne(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/agent/add"), data, {
    method
  });
}
// 推广管理 -- 推广团队管理--推广数据--删除单个推广员--250805
function deleteExtendOne(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/promotion/agent/del/${data.id}`),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 推广团队管理--推广数据--停工/解除单个停工--251104
function deleteStop(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/agent/stopWork"), data, {
    method
  });
}
// 推广管理 -- 欢迎派对-已审核 -- 取消推广身份
function deleteExtendTwo(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/agent/del"), data, {
    method
  });
}

// 推广管理 -- 推广邀请数据列表
function getInviteList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/invite/data"), data, {
    method
  });
}
//  推广管理 --- 绑定邀请关系
function addBound(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/invite"), data, {
    method
  });
}
// 推广管理 -- 解除绑定关系
function delBound(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/promotion/invite/${data.id}`),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 选择平台
function getPlatform(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/platform"), data, {
    method
  });
}
// 推广管理 -- 派对审核--列表
function getInviteParty(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply"), data, {
    method
  });
}
// 推广管理 -- 派对审核--审核
function getPartyAudit(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/invite/apply"), data, {
    method
  });
}

// 推广管理 -- 派对审核--删除
function deletePartyAudit(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/invite/apply/del/${data.id}`),
    data,
    {
      method
    }
  );
}

// 推广管理 -- 邀请数据中心 --列表
function getInvitePartyCenter(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply/ksa"), data, {
    method
  });
}
// 推广管理 -- 邀请数据中心 --审核
function getPartyAuditCenter(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/invite/apply/ksa"), data, {
    method
  });
}

// 推广管理 -- 区域统计 --列表
function getStatisticList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply/statistic"), data, {
    method
  });
}
// 推广管理 -- 人员审核统计 --列表
function getMgrStatsList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply/mgrStats"), data, {
    method
  });
}

// 推广管理 -- 邀请数据中心 --充值奖励发放
function getChargeAward(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/invite/apply/ksa/chargeAward"),
    data,
    {
      method
    }
  );
}

// 推广管理 -- 邀请月度结算数据 --列表
function getInviteMonth(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/promotion/month/settlement"),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 邀请月度结算数据【邀请充值明细】 --列表
function getInviteMonthChage(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/promotion/month/settlement/charge"),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 邀请月度结算数据【邀请新用户明细】 --列表
function getInviteMonthUser(data, method) {
  return ajax(
    "get",
    getRequestUrl("/v1/mgr/promotion/month/settlement/invite"),
    data,
    {
      method
    }
  );
}

//广场管理 -- 举报帖子列表
function findSnsMemberActionByPage(data, method) {
  return ajax("get", getRequestUrl("/mgrMoment/report/postlist"), data, {
    method,
    headers: {
      pkgname: "com.qiahao.nextvideo"
    }
  });
}
//广场管理 -- 举报评论列表
function reportSnsMonitorRecord(data, method) {
  return ajax("get", getRequestUrl("/mgrMoment/report/commentlist"), data, {
    method,
    headers: {
      pkgname: "com.qiahao.nextvideo"
    }
  });
}
//广场管理 -- 举报帖子列表 -- 处理帖子(删除/禁言/忽略)
function handlePostOperation(data, method) {
  return ajax(
    "post",
    getRequestUrl("/mgrMoment/report/postlist/handle"),
    data,
    {
      method,
      headers: {
        pkgname: "com.qiahao.nextvideo"
      }
    }
  );
}
//广场管理 -- 举报评论列表 -- 处理举报(删除/禁言/忽略)
function handleReportOperation(data, method) {
  return ajax(
    "post",
    getRequestUrl("/mgrMoment/report/commentlist/handle"),
    data,
    {
      method,
      headers: {
        pkgname: "com.qiahao.nextvideo"
      }
    }
  );
}
// 封禁社区 解除禁言
function handleUnbanPost(data, method) {
  return ajax(
    "post",
    getRequestUrl("/mgrMoment/permission/unblock/handle"),
    data,
    {
      method,
      headers: {
        pkgname: "com.qiahao.nextvideo"
      }
    }
  );
}
// 封禁社区 禁言
function handleBanPost(data, method) {
  return ajax(
    "post",
    getRequestUrl("/mgrMoment/permission/block/handle"),
    data,
    {
      method,
      headers: {
        pkgname: "com.qiahao.nextvideo"
      }
    }
  );
}
// 封禁社区 禁言状态详情
function handleBanStatus(data, method) {
  return ajax("get", getRequestUrl("/mgrMoment/permission/user"), data, {
    method,
    headers: {
      pkgname: "com.qiahao.nextvideo"
    }
  });
}

// 真人认证审核 -- 列表
function getCer(data, method) {
  return ajax("get", getRequestUrl("/v1/user/realCertification/page"), data, {
    method
  });
}
// 真人认证审核 -- 审核
function getPartyAuditCer(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/user/realCertification/review"),
    data,
    {
      method
    }
  );
}

// 操作日志管理-- 操作日志记录列表
function getOperation(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/operation/page"), data, {
    method
  });
}
// 操作日志管理-- 获取模块
function getModal(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/operation/module"), data, {
    method
  });
}
// 绑定手机-- 获取手机号
function getIphone(data, method) {
  return ajax("get", getRequestUrl("/v1/user/phone"), data, {
    method
  });
}
// 绑定手机
function bangDingIphone(data, method) {
  return ajax("post", getRequestUrl("/v1/user/phone"), data, {
    method
  });
}
// 查询区号
function getArea(data, method) {
  return ajax("get", getRequestUrl("/v1/h5/res/country"), data, {
    method
  });
}

// 获取版本列表
function getVersions(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/versionControl"), data, {
    method
  });
}
// 编辑版本
function getEditVersions(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/versionControl"), data, {
    method
  });
}

// 获取genToken
function genToken(data, method) {
  return ajax("get", getRequestUrl("/v1/inner/genToken"), data, {
    method
  });
}

// Echarts图表图形 -- 日充统计图
function getCac(data, method) {
  return ajax("get", getRequestUrl("/v1/dashboard/day/charge"), data, {
    method
  });
}
//
// Echarts图表图形 -- 日活统计图
function getDayUser(data, method) {
  return ajax("get", getRequestUrl("/v1/dashboard/day/user"), data, {
    method
  });
}
// 黑名单
// 获取黑名单列表
function getBlackList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/activity/blackList"), data, {
    method
  });
}
// 新增黑名单列表
function postBlackList(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/blackList"), data, {
    method
  });
}
// 删除黑名单用户
function delBlackList(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/activity/blackList/${data.userId}`),
    data,
    {
      method
    }
  );
}

// 白名单
// 获取白名单列表
function getWhiteList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/checkout/email"), data, {
    method
  });
}
// 新增白名单列表
function postWhiteList(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/checkout/email"), data, {
    method
  });
}
// 删除白名单用户
function delWhiteList(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/checkout/email/${data.userId}`),
    data,
    {
      method
    }
  );
}

// 登录白名单
// 名单列表
function getLoginWhiteList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/white/list"), data, {
    method
  });
}
// 用户拥有设备号
function getLoginimeiCode(data, method) {
  return ajax("get", getRequestUrl("/v1/user/white/imei/userCodes"), data, {
    method
  });
}
// 新增
function postLoginWhiteList(data, method) {
  return ajax("post", getRequestUrl("/v1/user/white/add"), data, {
    method
  });
}
// 删除
function delLoginWhiteList(data, method) {
  return ajax("delete", getRequestUrl(`/v1/user/white/del/${data.id}`), data, {
    method
  });
}

// 现金赛决赛最终排行数据--导出数据
function getXjsRank(data, method) {
  return ajax("get", getRequestUrl("/v1/export/act/xjsRank"), data, {
    method
  });
}
// 现金赛128名单充值数据--导出数据
function getXjsUser(data, method) {
  return ajax("get", getRequestUrl("/v1/export/act/xjsUserCharge"), data, {
    method
  });
}
// 收礼排行数据导出--导出数据
function getRecGift(data, method) {
  return ajax("get", getRequestUrl("/v1/export/act/recGift"), data, {
    method
  });
}
export default {
  getXjsRank,
  getXjsUser,
  getRecGift,
  putBannerRoomStatus,
  putBannerRoom,
  postBannerRoom,
  bannerAgentList,
  bannerAgentEdit,
  bannerAgentAdd,
  bannerAgentNouser,
  bannerAgentUse,
  bannerTaskList,
  bannerTaskEdit,
  bannerTaskAdd,
  bannerTaskSetStatus,
  getBannerRoom,
  bannerDiscovery,
  bannerDiscoveryEdit,
  bannerDiscoveryAdd,
  bannerDiscoveryNouser,
  bannerDiscoveryUse,
  bannerGame,
  bannerGameEdit,
  bannerGameAdd,
  bannerGameNouser,
  bannerGameUse,
  getgroupBanner,
  putPropertyon,
  putPropertyout,
  putHeadwearon,
  putHeadwearout,
  deleteVip,
  deleteImei,
  postImei,
  putGrouppower,
  putgroupPowerStatus,
  postDissolve,
  postGrouppower,
  getGrouppowerpage,
  putDiamondbill,
  uploadDiamondbill,
  getBatchPage,
  getYXBPage,
  uploadGameBill,
  putGameBill,
  uploadDiamondBatch,
  putDiamondBatch,
  getPropsPage,
  uploadPropsBatch,
  putPropsBatch,
  uploadPropsBatchY,
  putPropsBatchY,
  getSvipPage,
  uploadSvipbill,
  putSvipbill,
  getPointsPage,
  uploadPointsbill,
  putPointsbill,
  uploadPromotionBatch,
  getawardTask,
  postAwardTask,
  putAwardTask,
  deleteAwardTask,

  getawardConfigTask,
  postAwardConfigTask,
  putAwardConfigTask,
  deleteAwardConfigTask,

  getdistributionTask,

  putCodeAllBill,
  putAwardBill,
  putAwardOneBill,
  getBillpage,
  getGroupSupportStats,
  getGirlList,
  getAuditList,
  getAuditOperation,
  getGroupSupport,
  putCcountNormal,
  putCcountFrozen,
  getUserIncome,
  postUserIpDeal,
  postUserImeipDeal,
  getIpSame,
  getIpStatistics,
  getImeiSame,
  getImeiStatistics,
  putUserCountry,
  putUserAvatar,

  putEditAvatarCd,
  deleteAvatarCd,
  putEditNickCd,
  deleteNickCd,
  putEditPhotoCd,
  deletePhotoCd,

  postBeanReduce,
  getGuildUserGold,
  getGuildUserBean,
  getMedal,
  putMedal,
  getMedalUser,
  postMedalRemove,
  postMedalUser,
  postMedal,
  viplStatistics,

  postHeadwearUser,
  postHeadwearRemove,
  getHeadwearUser,
  putHeadwear,
  postHeadwear,
  getHeadwear,
  postGroupTheme,
  putGroupTheme,
  putGroupThemeSwitch,
  getGroupTheme,
  getCyclestats,
  postEmoji,
  putEmoji,
  emojiSwitch,
  getemoji,
  login: login,
  loginOut,
  checkAdminPwd,
  exportData: exportData,
  upload,
  getAdminList,
  createAdmin,
  deleteAdmin,
  updateAdmin,
  getPermission,
  editPermission,
  settCountryList,
  // settDataAreaList,
  setSave,
  setUserSave,
  setAgencySave,
  setDataAreaSave,
  setBroadcastSave,
  delBroadcastSave,
  setIsManagerSave,
  delIsManagerSave,
  setRoomSave,
  delSetRoomSave,
  setMicrophoneSave,
  delMicrophoneSave,
  setRoomManagerSave,
  delRoomManagerSave,
  setDataSave,
  delDataSave,
  giftIndex,
  giftUpdate,
  giftCreate,
  giftSwitch,
  giftDetail,
  reportFeedbacks,
  reportList,
  reportBanUser,
  reportHandle,
  usersList,
  updateSex,
  updateRecommend,
  userUnionUpdate,
  usersConnects,
  usersPayments,
  usersConsume,
  usersPaymentsCreate,
  usersSendGameMonty,
  statsConsume,
  diamondReduce,
  goldReduce,
  usersVipCreate,
  userSearch,
  userDeal,
  userBroadcast,
  relieveUserBroadcast,
  // userTradeUnionDel,
  banDevice,
  unBanDevice,
  getCountryList,
  getCountryArea,
  getCountryListTwo,
  userRecommend,
  unionUserList,
  unionConnectList,
  associationAvatar,
  unionConnectDetail,
  unionConnectStats,
  updateAgentUnion,
  updateAgentName,
  agentListPage,
  addAgentPage,
  editAgentPage,
  deleteAgentPage,
  editAgentMgr,
  deleteAgentMgr,
  setStarchatId,
  matchCyclePage,
  matchCyclePageDetail,
  matchLogSTotalDetail,
  matchLogSRelation,
  matchLogExcellent,
  matchLogRelationTop,
  matchLogSingle,
  matchRpc,
  dailyStatistics,
  monthStatistics,
  totalStatistics,
  weekStatistics,
  rechargeStatistics,
  consumeStatistics,
  recommendPage,
  recommendDel,
  managerPage,
  managerEdit,
  managerAdd,
  managerNoUser,
  dayStatsList,
  monthStatsList,
  promotionStatsList,
  dealerStatsList,
  getCountryListTree,
  agentAll,
  advertiseList,
  advertiseEdit,
  advertiseAdd,
  advertiseSwitch,
  activityList,
  activityEdit,
  activityAdd,
  manageDel,
  resetAvatar,
  getUserPhoto,
  photoDelete,
  updateUserNick,
  updateUserLevel,
  updateUserCode,
  resetUserCode,
  checkProp,
  deleteProp,
  diamondIncomeList,
  giftOperateList,
  deleteAdministration,
  createCode,
  banInterface,
  banRescind,
  propertyEdit,
  propertyAdd,
  propertyAddToUser,
  propertyRemoveToUser,
  propertyList,
  propertyUserList,
  groupList,

  putEditNameCd,
  deleteEditNameCd,
  putEditIntroductionCd,
  deleteEditIntroductionCd,
  putEditNotificationCd,
  deleteEditNotificationCd,
  putGroupEditAvatarCd,
  deleteEditAvatarCd,
  putGroupEditCustomThemeCd,
  deleteEditCustomThemeCd,

  groupAllow,
  groupBan,
  groupOnTop,
  groupOnTopCancel,
  groupProfile,
  putGroupCustomTheme,
  deleteGroupCustomTheme,
  groupBeautifulCodePut,
  groupBeautifulCodeDelete,
  getBannerPage,
  getBannerTimePage,
  addBannerPage,
  editBannerPage,
  deleteBannerPage,
  deleteBannerTimePage,
  bannerManagementList,
  bannerManagementEdit,
  bannerManagementAdd,
  bannerManagementNouser,
  bannerManagementUse,

  permissionModule,
  putGrouphide,
  putPolicy,
  putRecommend,
  roleList,
  getAddRole,
  delRole,
  blackList,
  getAddBlack,
  delBlack,
  getRoomList,
  getAddCreateAct,
  getUpdateAct,
  actSwitch,
  getExamineList,
  getPrivilegeList,
  getRoomSpecList,
  getAddSpecAct,
  getUpdateSpecAct,
  getCopySpecAct,
  actSpecSwitch,
  getExamineSpeList,
  getBackend,
  getTaskSpecAct,
  getAddTaskSpecAct,
  getEditTaskSpecAct,
  delTaskSpecAct,
  getCopyTaskSpecAct,
  getAwardSpecAct,
  getAddAwardSpecAct,
  getEditAwardSpecAct,
  delAwardSpecAct,
  selectPromoter,
  editPromoter,
  dealerList,
  editDetailList,
  frozenFu,
  getDealerCountryList,
  dealerChargeList,
  dealerSummaryList,
  agentCreate,
  agentCreateEdit,
  // agentUpdate,
  agentSwitch,
  agentCurrency,
  detailList,
  distributionDetailList,
  countrySave,
  countryList,
  secondList,
  secondAddOrEdit,
  secondOrEdit,
  deductListDG,
  deductDGOrEdit,
  giftList,
  weekGiftCreate,

  getPrizePage,
  getPrizeDraw,
  getPrizeDetail,
  getPrizeEdit,
  getPrizeAdd,
  // IPCount,
  prizeUse,
  prizeUseNo,

  getPrizePageH5,
  getPrizeDrawH5,
  getPrizeDetailH5,
  getPrizeEditH5,
  getPrizeAddH5,
  // IPCount,
  prizeUseH5,
  prizeUseNoH5,
  boxAwardList,
  boxStakeList,

  advertisingFlashScreen,
  advertisingEdit,
  advertisingAdd,
  advertisingNouser,
  advertisingUse,

  openFlashScreen,
  openEdit,
  openAdd,
  openNouser,
  openUse,

  groupPKList,
  groupPKDetail,
  groupPKDel,
  groupPKUpdate,
  groupPKAdd,
  pkUse,
  pkUseNo,
  groupPKAward,
  groupPKExcel,

  statisticsList,
  dayDetailList,
  dayAwardList,
  dayStakeList,
  gameFruitsAsc,
  gameFruitsDesc,
  gameFruitsScriptList,
  gameFruitsScriptExecList,
  getAddFruitsScript,
  getDeleteFruitsScript,

  rebateGiftList,
  // dayGiftDetailList,
  dayGiftAwardList,
  dayGiftStakeList,
  gameGiftAsc,
  gameGiftDesc,

  footballList,
  dayDetailFootballList,
  dayAwardFootballList,
  dayStakeFootballList,
  gameFootballAsc,
  gameFootballDesc,
  gameFootballScriptList,
  gameFootballScriptExecList,
  getAddFootballScript,
  getDeleteFootballScript,

  slotAwardList,
  slotStakeList,
  candyAwardList,
  candyStakeList,
  greedyAwardList,
  greedyStakeList,
  gameSlotDayList,
  gameSlotAwardList,
  gameSlotStakeList,
  statisticsRaceList,
  dayRaceDetailList,
  gameRaceAwardList,
  gameRaceStakeList,
  gameRaceStakeAsc,
  gameRaceStakeDesc,
  gameRaceScriptList,
  gameRaceScriptExecList,
  getAddScript,
  getDeleteScript,
  addBroadcastAdministrator,
  delBroadcastAdministrator,
  sendNobility,
  sendProps,
  addTradeUnion,
  deleteTradeUnion,
  countryAdministration,

  statisticsEgyptList,
  EgyptAwardList,
  EgyptStakeList,

  statisticsFishList,
  FishAwardList,
  FishStakeList,
  statisticsFootballList,
  FootballAwardList,
  FootballStakeList,

  statisticsWitchList,
  WitchAwardList,
  WitchStakeList,

  statisticsTeenpList,
  TeenpAwardList,
  TeenpStakeList,
  statisticsFoodieList,
  dayDetailFoodieList,
  dayAwardFoodieList,
  dayStakeFoodieList,
  gameFoodieAsc,
  gameFoodieDesc,

  statisticsCatFoodieList,
  dayDetailCatFoodieList,
  dayAwardCatFoodieList,
  dayStakeCatFoodieList,
  gameCatFoodieAsc,
  gameCatFoodieDesc,

  statisticsdDeliciousList,
  dayDetailDeliciousList,
  dayAwardDeliciousList,
  dayStakeDeliciousList,
  gameDeliciousAsc,
  gameDeliciousDesc,

  userLeave,
  addManager,
  delManager,
  bigwigList,
  chargePayments,
  refundDetail,
  whiteBlackDetail,
  whiteBlackAdd,
  whiteBlackEdit,
  delRollAct,
  refundSummary,
  checkDeviceList,
  deviceAdd,
  // deviceEdit,
  delDevice,
  checkIpList,
  IpAdd,
  // IpEdit,
  delIp,
  teamsRemove,
  teamsRemoveSure,
  agentsRemove,
  agentsRemoveSure,
  newUserInvite,
  newUserList,
  resultStatistics,
  newUserStatistics,
  newUserState,
  videoChatStatistics,
  massTextingIM,
  withdrawInfoGroup,
  getMassTextingPage,
  newGroupInvite,
  groupAuditList,
  groupAuditStatistics,
  goldList,
  getTemplateAct,
  getAddTemplateAct,
  getEditTemplateAct,
  getGiftAct,
  getUpdateGiftAct,
  delTemplateAct,
  getCopyAct,
  getTaskAct,
  getAddTaskAct,
  getEditTaskAct,
  delTaskAct,
  getCopyTaskAct,
  getAwardAct,
  getAddAwardAct,
  getEditAwardAct,
  delAwardAct,
  uploadTeamUser,
  getTeamUser,
  putTeamUser,
  downloadRank,
  getUserRecharge,
  amassUser,
  amassUserSvip,
  getListAct,
  getMendAct,
  getRebList,
  getRebAdd,
  getRebEdit,
  getRebCopy,
  getRebDel,

  getPopupList,
  getPopupAdd,
  getPopupEdit,
  getPopupDel,

  getTurntableAdd,
  getTurntablePut,
  getTurntableDel,
  getCopyTurn,
  getTurntableList,
  getTurnAwardAdd,
  getTurnAwardPut,
  getTurnAwardDel,
  getTurnAwardList,
  getTurnStatisticsList,
  getTurnDetailList,

  getTeamList,
  getAgentsList,
  getDeleteTeam,
  amendIDFun,
  getSelectList,
  addTeam,
  editTeam,
  pushMsgTeam,
  editDataList,
  addExtendOne,
  deleteExtendOne,
  deleteStop,
  deleteExtendTwo,
  getInviteList,
  addBound,
  delBound,
  getPlatform,
  getInviteParty,
  getPartyAudit,
  deletePartyAudit,
  getInvitePartyCenter,
  getPartyAuditCenter,
  getStatisticList,
  getMgrStatsList,
  getChargeAward,
  getInviteMonth,
  getInviteMonthChage,
  getInviteMonthUser,
  // 广场管理
  findSnsMemberActionByPage,
  reportSnsMonitorRecord,
  handlePostOperation,
  handleReportOperation,
  handleUnbanPost,
  handleBanPost,
  handleBanStatus,
  // 广场管理 end
  getCer,
  getPartyAuditCer,
  getOperation,
  getModal,
  getIphone,
  bangDingIphone,
  getArea,
  getVersions,
  getEditVersions,
  genToken,
  getCac,
  getDayUser,
  getNameplate,
  putNameplate,
  postNameplate,
  getNameplateUser,
  postNameplateRemove,
  postNameplateUser,
  userMemo,
  userSvipLevel,
  userPointCount,
  userSvipPoints,
  userSvipTime,
  getBlackList,
  delBlackList,
  postBlackList,
  getWhiteList,
  postWhiteList,
  delWhiteList,
  getIDOrnament,
  putIDOrnament,
  postIDOrnament,
  getIDOrnamentUser,
  postIDOrnamentRemove,
  postIDOrnamentUser,
  getLoginWhiteList,
  getLoginimeiCode,
  postLoginWhiteList,
  delLoginWhiteList,

  getRoomLabel,
  putRoomLabel,
  postRoomLabel,
  getRoomLabelUser,
  postRoomLabelRemove,
  postRoomLabelUser,

  getRoomHeader,
  putRoomHeader,
  postRoomHeader,
  getRoomHeaderUser,
  postRoomHeaderRemove,
  postRoomHeaderUser,

  getUserOrnaments,
  putUserOrnaments,
  postUserOrnaments,
  getUserOrnamentsUser,
  postUserOrnamentsRemove,
  postUserOrnamentsUser,

  getPersonal,
  putPersonal,
  postPersonal,
  getPersonalUser,
  postPersonalRemove,
  postPersonalUser,

  getTaillight,
  putTaillight,
  postTaillight,
  getTaillightUser,
  postTaillightRemove,
  postTaillightUser,

  getMicrophone,
  putMicrophone,
  postMicrophone,
  getMicrophoneUser,
  postMicrophoneRemove,
  postMicrophoneUser,

  getBubbleBox,
  putBubbleBox,
  postBubbleBox,
  getBubbleBoxUser,
  postBubbleBoxRemove,
  postBubbleBoxUser,

  // 拉新房间管理 -zy
  getInviteNewGroupList(data, method) {
    return ajax("get", getRequestUrl("/v1/mgr/inviteNewGroup/list"), data, {
      method
    });
  },
  postInviteNewGroupAdd(data, method) {
    return ajax("post", getRequestUrl("/v1/mgr/inviteNewGroup/add"), data, {
      method
    });
  },
  putInviteNewGroupEdit(data, method) {
    return ajax("put", getRequestUrl("/v1/mgr/inviteNewGroup/update"), data, {
      method
    });
  },
  deleteInviteNewGroup(data, method) {
    return ajax(
      "delete",
      getRequestUrl("/v1/mgr/inviteNewGroup/delete"),
      data,
      {
        method
      }
    );
  },
  // 房间管理列表
  getGroupList(data, method) {
    return ajax("get", getRequestUrl("/v1/group/stat"), data, {
      method
    });
  },

  // 房间管理可见国家
  getGroupCountryList(data, method) {
    return ajax("get", getRequestUrl("/v2/groupCountry/country/list"), data, {
      method
    });
  },
  // 设置房间管理可见国家
  setGroupCountry(data, method) {
    return ajax("post", getRequestUrl("/v1/groupCountry/set"), data, {
      method
    });
  }
};



// WEBPACK FOOTER //
// ./src/js/http.js